import React from 'react';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {Button, Dropdown} from 'react-bootstrap';
import styles from './styles.module.scss';
import classNames from 'classnames';

const CustomToggle = React.forwardRef(({children, onClick}, ref) => (
  <Button
    type="button"
    className={classNames(styles.buttonToggle, 'btn btn-sm p-0')}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    ref={ref}
  >
    <img
      src={toAbsoluteUrl('/media/svg/Sort_white.svg')}
      alt="sort"
      height={24}
    />
  </Button>
));

const ButtonSmartFilter = ({
                             header,
                             children
                           }) => {

  return (
    <Dropdown autoClose={false}>
      <Dropdown.Toggle as={CustomToggle} id="dropdown-basic"/>
      <Dropdown.Menu alignRight={true} className={styles.smartFilterMenu}>
        <h6 className={styles.smartFilterHeader}>
          {header}
        </h6>
        {children}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ButtonSmartFilter;
